<button nbButton size="small" title="{{ tooltip }}">{{ text ? text : 'New' }}</button>
